import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import mfyReducer from '~scenes/madeforyou/app/reducers/mfyReducer';

const store = createStore(mfyReducer, {}, applyMiddleware(thunk));

export default store;
